import { ChangeEventHandler, ComponentProps, FC, useCallback } from 'react';

import { InputBaseWithOptions } from '../Input.type';
import { FieldWrapperOptionsGroup } from '../atoms/FieldWrapper';
import { ControlInputOption } from './ControlInputOption';

type Props<InputValue = any> = Prettify<
  Omit<InputBaseWithOptions<InputValue>, 'variant'> &
    Pick<ComponentProps<typeof ControlInputOption>, 'type' | 'inputIcon' | 'variant'> & {
      onDelete?: (optionValue: string) => void;
    }
>;

export const ControlInputGroup: FC<Props> = ({ type, onChange, onBlur, onDelete, inputIcon, variant, ...props }) => {
  const changeHandler: ChangeEventHandler<HTMLInputElement> = useCallback(
    (event) => {
      if (onChange) {
        // Handles the event differently depending on the current value type
        if (Array.isArray(props.value) || type === 'checkbox') {
          onChange(
            toggleValueInArray(event.target.value, Array.isArray(props.value) ? props.value : []),
            event.target.value,
          );
        } else {
          onChange(event.target.checked ? event.target.value : '');
        }
      }
    },
    [props.value, onChange, type],
  );

  return (
    <FieldWrapperOptionsGroup {...props} type={type}>
      {props.options.map((option) => (
        <ControlInputOption
          {...props}
          type={type}
          option={option}
          onChange={changeHandler}
          onBlur={onBlur}
          onDelete={onDelete ? () => onDelete(option.value) : undefined}
          key={option.value}
          inputIcon={inputIcon}
          variant={variant}
        />
      ))}
    </FieldWrapperOptionsGroup>
  );
};

const toggleValueInArray = (currentValue: string, inputValue: string[]): string[] => {
  let newInputValue = [...inputValue];
  if (inputValue.indexOf(currentValue) >= 0) {
    // Remove the value
    newInputValue = newInputValue.filter((value) => value !== currentValue);
  } else {
    // Add the value
    newInputValue.push(currentValue);
  }

  return newInputValue;
};
